import { useEffect, useRef } from "react";
import { invoke } from "../lib/bridge";

// Listens for the `fam:unauthorized` event that api.ts emits when the server
// rejects this device's auth (a 401) — which means the member was removed from
// the family (e.g. booted on a downgrade to Free). It wipes local state via
// `force_logout` and then calls `onLoggedOut` so the app can return to onboarding,
// preventing stale family data from staying readable on this device.
//
// Deduped: the sync poll and chat both fire near-simultaneous 401s, but we only
// log out once per component lifetime. The callback is read through a ref so the
// listener can stay mounted once without going stale.
export function useForcedLogout(onLoggedOut: () => void): void {
  const onLoggedOutRef = useRef(onLoggedOut);
  onLoggedOutRef.current = onLoggedOut;

  useEffect(() => {
    let handled = false;
    const handler = async () => {
      if (handled) return;
      handled = true;
      try {
        await invoke("force_logout");
      } catch {
        /* clearing local state is best-effort */
      }
      onLoggedOutRef.current();
    };
    window.addEventListener("fam:unauthorized", handler);
    return () => window.removeEventListener("fam:unauthorized", handler);
  }, []);
}
